<template>
  <div>
    <header>
      <h1>Package</h1>
      <p>Choose the best option for yourself and enjoy the benefits of the package</p>
    </header>

    <div class="period-switch">
      <label class="switch">
        <input
          type="checkbox"
          :checked="period === 'yearly'"
          @change="changePeriod($event.target.checked)"
        />
        <span class="slider"></span>
        <span class="title">
          <p>Monthly</p>
          <p>Yearly</p>
        </span>
      </label>
    </div>

    <div class="packages">
      <div class="package-block">
        <div class="info">
          <h3>Premium</h3>
          <p>${{ amount.usd.toFixed(2) }}</p>
        </div>

        <div class="description">
          Get more opportunities with a premium account,
          watch movies and TV shows in excellent quality on a device convenient for you
        </div>
      </div>
    </div>

    <table class="premium-benefits">
      <tr>
        <th></th>
        <th>Premium</th>
        <th>Free</th>
      </tr>

      <tr v-for="item in premiumBenefits" :key="item.title">
        <td>{{ item.title }}</td>
        <td><i v-bind:class="{ checked: item.premium }"></i></td>
        <td><i v-bind:class="{ checked: item.free }"></i></td>
      </tr>
    </table>

    <div class="payment-methods">
      <h2>Payment method</h2>

      <div class="method-buttons">
        <router-link class="credit-card" to="/account/subscription/payment/creditcard">
          CreditCard
        </router-link>

        <router-link class="credit-card" to="/account/subscription/payment/sla">
            SMS
        </router-link>

        <router-link
          v-if="allowedKnetServices"
          class="credit-card"
          to="/account/subscription/payment/knet">
          KNET
        </router-link>
      </div>
    </div>

    <p v-if="error" style="color: red">Error: {{ error }}</p>

    <router-view />

    <FaqList />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import FaqList from '@/shared/components/FaqList.vue';
import store from '@/store';

export default {
  name: 'SubscriptionPayment',
  components: {
    FaqList,
  },
  async beforeRouteEnter(to, from, next) {
    await store.dispatch('payment/getSubscription');

    const hasSub = store.getters['payment/hasSubscription'];

    if (hasSub) {
      next('/account/subscription');
    } else {
      next();
    }
  },
  data: () => ({
    premiumBenefits: [
      { title: 'Enjoy content in HD & 4k', premium: true, free: false },
      { title: 'No Ads', premium: true, free: false },
      { title: 'Access to exclusive restored premium content', premium: true, free: false },
      { title: 'Livestreams in HD', premium: true, free: false },
      { title: "Apple TV & smart TV's", premium: true, free: false },
      { title: 'Exclusive original content', premium: true, free: false },
    ],
  }),
  computed: {
    ...mapState('payment', ['error', 'amount', 'period', 'allowedKnetServices']),
  },
  methods: {
    changePeriod(isYearly) {
      this.$store.commit('payment/setPeriod', isYearly ? 'yearly' : 'monthly');
    },
  },
  created() {
    this.$store.commit('payment/setPeriod', 'monthly');
  },
};
</script>

<style lang="less" scoped>
  header {
    display: block;
    text-align: center;

    h1 {
      font-size: 2rem;
      margin: 0;
    }

    p {
      font-size: 1rem;
    }
  }

  .period-switch {
    text-align: center;
    margin-top: 60px;
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 170px;
    height: 45px;
    cursor: pointer;

    .title {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-between;

      p {
        padding: 0;
        color: #888;
        transition: .4s;
        font-weight: bold;

        &:first-child {
          padding-left: 13px;
        }

        &:last-child {
          padding-right: 18px;
        }
      }
    }

    input {
      opacity: 0;
      width: 0;
      height: 0;

      &:checked + .slider:before {
        transform: translateX(85px);
      }

      &:checked + .slider + .title p:last-child {
        color: #202020;
      }

      &:not(:checked) + .slider + .title p:first-child {
        color: #202020;
      }
    }

    .slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #333;
      transition: .4s;
      border-radius: 67px;
    }

    .slider:before {
      position: absolute;
      content: "";
      height: 45px;
      width: 85px;
      left: 0;
      bottom: 0;
      background-color: #7ce7f2;
      transition: .4s;
      border-radius: 67px;
    }
  }

  .packages {
    margin-top: 30px;

    .package-block {
      padding: 20px 30px;
      border-radius: 5px;
      background-color: #171717;
      display: flex;

      .info {
        width: 90px;
        flex-shrink: 0;
        flex-flow: 0;
        border-right: 1px solid #595959;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        h3 {
          margin: 0;
          font-size: 1rem;
          font-weight: normal;
          color: #b5b5b5;
        }

        p {
          margin: 10px 0 0;
          color: #fff;
          font-size: 1.5rem;
        }
      }

      .description {
        font-size: 0.75rem;
        color: #888;
        padding-left: 30px;
        display: flex;
        align-items: center;
        line-height: 1.125rem;
      }
    }
  }

  .premium-benefits {
    width: 100%;
    margin-top: 60px;
    border-spacing: 0;

    tr:nth-child(even) td {
      background-color: #171717;
    }

    tr:last-child td {
      border-bottom: 1px solid #595959;
    }

    th {
      padding: 13px 0;
    }

    td {
      text-align: center;
      color: #8b8b8b;
      border-top: 1px solid #595959;
      padding: 13px 0;
      width: 20%;

      &:first-child {
        width: 60%;
        text-align: left;
        padding: 0 20px;
      }
    }

    i {
      display: inline-block;
      width: 14px;
      height: 11px;

      &.checked {
        background-image: url('../../../../assets/images/checked-icon.svg');
      }

      &:not(.checked) {
        position: relative;
        &::after {
          content: '';
          position: absolute;
          top: 50%;
          left: 0;
          width: 100%;
          height: 1px;
          background-color: #565656;
        }
      }
    }

  }

  .payment-methods {
    margin-top: 60px;

    h2 {
      font-weight: normal;
    }

    .method-buttons {
      display: flex;

      a {
        display: block;
        padding: 10px 20px;
        position: relative;

        &::after {
          content: '';
          display: none;
          position: absolute;
          bottom: 0;
          left: 0;
          height: 3px;
          background-color: #7CE7F2;
          width: 100%;
        }

        &.active::after {
          display: block;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .premium-benefits {
      td {
        font-size: 0.75rem;
      }
    }

    .payment-methods {
      .method-buttons {
        margin-left: -25px;
        margin-right: -25px;
        justify-content: space-between;

        a {
          flex: 1;
          padding: 10px;
          text-align: center;
        }
      }
    }
  }
</style>
